import { BaseContainerModel } from "../base-container.model";
import {
  bl_mkp_tmp_seller_order_line_Rowinterface,
  bl_mkp_tmp_seller_order_line_Rowclass,
} from "../../dbschema/index";

export class TmpSellerOrderLineContainerModel extends BaseContainerModel {
  bl_mkp_tmp_seller_order_line: bl_mkp_tmp_seller_order_line_Rowinterface =
    new bl_mkp_tmp_seller_order_line_Rowclass();
} 
